import { ServicePrescription } from '@/service/prescription/servicePrescription'
const servicePrescription = new ServicePrescription()
import { ServiceRecordsPrescription } from '@/service/prescription/serviceRecordPrescription'


export default {
  namespaced: true,
  state: {
    prescription: {
      prescriptionModeloSelected: null,
      medicamentsSelected: [],
      selectVia: null,
      qtd: '',
      selectCondicao: null,
      uso: '',
    },
    prescriptionModelos: [],
    prescriptionModeloSelected: {},
    medicines: [],
    loadingModelo: false,
    viaOptions: [
      { name: 'Inalatória' },
      { name: 'Intracaverno' },
      { name: 'Inj.IM' },
      { name: 'Inj.IV' },
      { name: 'Inj.SC' },
      { name: 'Intranasal' },
      { name: 'Ocular' },
      { name: 'Oral' },
      { name: 'Otologica' },
      { name: 'Retal' },
      { name: 'Sublingual' },
      { name: 'Topical' },
      { name: 'Uso Externo' },
      { name: 'Vaginal' },
      { name: 'Vestimenta' },
    ],
    condicaoOptions: [
      { titulo: 'Uso Continuo' },
      { titulo: 'Se Dor' },
      { titulo: 'Se Febre' },
      { titulo: 'Se Dor ou Febre' },
      { titulo: 'Se Náuseas/Vômitos' },
    ],
    addPrescription: [],
    payloadRecordPrescription: {
      record_id: null,
      customer_id: null,
      prescription_id: null,
      schedule_id: null,
    },
  },
  getters: {
    getPrescription(state) {
      return state.prescription
    },
    getPrescriptionModelos(state) {
      return state.prescriptionModelos
    },
    getPrescriptionModeloSelected(state) {
      return state.prescriptionModeloSelected
    },
    getMedicines(state) {
      return state.medicines
    },
    getLoadingModelo(state) {
      return state.loadingModelo
    },
    getViaOptions(state) {
      return state.viaOptions
    },
    getCondicaoOptions(state) {
      return state.condicaoOptions
    },
    getAddPrescription(state) {
      return state.addPrescription
    },
    getPayloadRecordPrescription(state) {
      return state.payloadRecordPrescription
    },
  },
  mutations: {
    setPrescription(state, data) {
      state.prescription = data
      state.prescriptionModeloSelected = data.prescriptionModeloSelected
    },
    setPrescriptionModelos(state, data) {
      state.prescriptionModelos = data
    },
    setPrescriptionModeloSelected(state, data) {
      state.prescriptionModeloSelected = data
    },
    setLoadingModelo(state, loading) {
      state.loadingModelo = loading
    },
    setMedicines(state, medicines) {
      state.medicines = medicines
    },
    setAddPrescription(state, data) {
      state.addPrescription = data
    },
    setPrescriptionId(state, id) {
      state.payloadRecordPrescription.prescription_id = id
    },
    setRecordId(state, id) {
      state.payloadRecordPrescription.record_id = id
    },
    setCustomerId(state, id) {
      state.payloadRecordPrescription.customer_id = id
    },
    setScheduleId(state, id) {
      state.payloadRecordPrescription.schedule_id = id
    },
  },
  actions: {
    async createPrescription({ commit }, data) {
      const response = await servicePrescription.createPrescription(data)
      commit('setPrescription', response.data)
      commit('setPrescriptionId', response.data.data.id)
    },
    async fetchPrescriptionModelo({ commit }) {
      commit('setLoadingModelo', true)
      const response = await servicePrescription.fetchPrescriptionModelo({ is_model: true })
      commit('setPrescriptionModelos', response.data)
      commit('setLoadingModelo', false)
    },
    async fetchMedicines({ commit }, query) {
      const params = {
        nome: query,
        pagina: 1,
      }
      const response = await servicePrescription.fetchMedicines(params)
      commit('setMedicines', response.content)
    },
    async deletePrescription({ commit }, query) {
      await servicePrescription.deletePrescription(query)
    },

  },

}
